import React from 'react'
import { Trans } from '@lingui/macro'
import Tag, { TagColorsEnum } from '../../../../../components/common/tag/Tag'
import { Flex, Text } from 'front-end/src/components'
import { cx } from '@emotion/css'
import './QuizScore.less'
import {
  fontSizes,
  fontWeights,
  radii
} from 'front-end/src/components/chakraThemeExtension'
import { brandColors } from 'shared/basicPalette'
import { round } from 'lodash'

interface IProps {
  percentages: number
  tagText: string
  tagColor: TagColorsEnum
  classes?: string
}

const QuizScore = ({ percentages, tagText, tagColor, classes }: IProps) => {
  return (
    <Flex
      textAlign="center"
      bgColor="white"
      direction="column"
      borderRadius={radii.md}
      pt="8px"
      minW="86px"
      className={cx('QuizScore', classes)}
    >
      <Text as="span" fontSize={fontSizes.ssm} color={brandColors.grey.mid}>
        <Trans>Score</Trans>
      </Text>
      <Text
        as="span"
        fontSize={fontSizes['2xl']}
        fontWeight={fontWeights.medium}
        mb="8px"
      >
        {round(percentages, 1)}%
      </Text>
      <Tag color={tagColor}>{tagText}</Tag>
    </Flex>
  )
}

export default QuizScore
